import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import API_BASE_URL from "../config/api";

function Signup() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email_id: "",
    password: "",
    mobile_no: "",
  });

  const [errors, setErrors] = useState({});
  const [agree, setAgree] = useState(false);
  const [loading, setLoading] = useState(false);

  /* ================= GOOGLE INIT ================= */
  useEffect(() => {
    if (window.google && document.getElementById("googleSignUpDiv")) {
      window.google.accounts.id.initialize({
        client_id:
          "956569074304-5scv2ocl4pdut7659l9msuio6li95e0d.apps.googleusercontent.com",
        callback: handleGoogleResponse,
      });

      window.google.accounts.id.renderButton(
        document.getElementById("googleSignUpDiv"),
        {
          theme: "outline",
          size: "large",
          width: "100%",
          text: "signup_with",
        }
      );
    }
  }, []);

  /* ================= GOOGLE RESPONSE ================= */
  const handleGoogleResponse = async (response) => {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/student_signup.php`,
        { credential: response.credential },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.success) {
        await Swal.fire({
          icon: "success",
          title: "Signup Successful",
          timer: 1200, 
          showConfirmButton: false
        });
       // console.log("Google Signup Response:", res.data.user);
        sessionStorage.setItem("user", JSON.stringify(res.data.user));
        sessionStorage.setItem("verifyNo", "N");
        
        navigate("/complete-profile");
         


      } else {
        Swal.fire({
          icon: "info",
          title: "Sign Up",
          text: res.data.message || "Google signup failed",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Something went wrong",
      });
    }
  };

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  /* ================= VALIDATION ================= */
  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Full name is required";

    if (!formData.email_id.trim())
      newErrors.email_id = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email_id))
      newErrors.email_id = "Enter valid email";

    if (!formData.password.trim())
      newErrors.password = "Password is required";
    else if (formData.password.length < 8)
      newErrors.password = "Minimum 8 characters required";

    if (!formData.mobile_no.trim())
      newErrors.mobile_no = "Mobile number is required";
    else if (!/^[0-9]{10}$/.test(formData.mobile_no))
      newErrors.mobile_no = "Enter valid 10-digit number";

    if (!agree)
      newErrors.terms = "You must accept Terms & Conditions";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ================= NORMAL SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    try {
      const form = new FormData();
      Object.entries(formData).forEach(([k, v]) =>
        form.append(k, v)
      );

      const res = await axios.post(
        `${API_BASE_URL}/student_signup.php`,
        form
      );

      if (res.data.success) {
        await Swal.fire({
          icon: "success",
          title: "Signup Successful",
          text: "Please verify OTP to continue",
           timer: 1200, 
          showConfirmButton: false
        });

        navigate("/otpverification", {
          state: { userid: res.data.userid },
        });
      } else {
        Swal.fire({
           icon: "info",
          title: "Sign Up",
          text: res.data.message || "Please try again",
        });
      }
    } catch {
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="gray-simple">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-7 col-md-9 col-sm-12">
            <div className="card rounded-4 shadow-lg mt-5">
              <div className="card-body p-4 p-md-5">

                <div className="text-center mb-4">
                  <h3 className="fw-bold" style={{ color: "#176fb0" }}>
                    Create Account
                  </h3>
                  <p className="text-muted">
                    Start your aviation journey
                  </p>
                </div>

                <form onSubmit={handleSubmit} noValidate>
                  <div className="row g-4">

                    {/* NAME */}
                    <div className="col-12">
                      <label className="form-label fw-semibold">Full Name <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className={`form-control ${errors.name ? "border-danger" : ""}`}
                      />
                      {errors.name && <small className="text-danger">{errors.name}</small>}
                    </div>

                    {/* EMAIL */}
                    <div className="col-12">
                      <label className="form-label fw-semibold">Email Address <span className="text-danger">*</span></label>
                      <input
                        type="email"
                        name="email_id"
                        value={formData.email_id}
                        onChange={handleChange}
                        className={`form-control ${errors.email_id ? "border-danger" : ""}`}
                      />
                      {errors.email_id && <small className="text-danger">{errors.email_id}</small>}
                    </div>

                    {/* PASSWORD */}
                    <div className="col-12">
                      <label className="form-label fw-semibold">Password <span className="text-danger">*</span></label>
                      <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        className={`form-control ${errors.password ? "border-danger" : ""}`}
                      />
                      {errors.password && <small className="text-danger">{errors.password}</small>}
                    </div>

                    {/* MOBILE */}
                    <div className="col-12">
                      <label className="form-label fw-semibold">Mobile Number <span className="text-danger">*</span></label>
                      <input
                        type="tel"
                        name="mobile_no"
                        value={formData.mobile_no}
                        onChange={handleChange}
                        className={`form-control ${errors.mobile_no ? "border-danger" : ""}`}
                      />
                      {errors.mobile_no && <small className="text-danger">{errors.mobile_no}</small>}
                    </div>

                    {/* TERMS */}
                    <div className="col-12">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={agree}
                          onChange={(e) => setAgree(e.target.checked)}
                        />
                        <label className="form-check-label small">
                          I agree to the{" "}
                          <Link
                            to="/terms-conditions"
                            style={{ color: "#1472b5", fontWeight: "700", textDecoration: "none" }}
                          >
                            Terms & Conditions
                          </Link>{" "}
                          and{" "}
                          <Link
                            to="/privacy-policy"
                            style={{ color: "#1472b5", fontWeight: "700", textDecoration: "none" }}
                          >
                            Privacy Policy
                          </Link>
                        </label>

                      </div>
                      {errors.terms && <small className="text-danger">{errors.terms}</small>}
                    </div>

                    {/* REGISTER BUTTON */}
                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn w-100 py-2 fw-semibold"
                        style={{
                          background: "linear-gradient(135deg,#176fb0,#0b4f86)",
                          color: "#fff",
                          borderRadius: "14px",
                        }}
                        disabled={loading}
                      >
                        {loading ? "Registering..." : "Register Now"}
                      </button>
                    </div>

                    {/* DIVIDER */}
                    <div className="col-12 text-center my-3">
                      <div className="d-flex align-items-center">
                        <hr className="flex-grow-1" />
                        <span className="mx-2 text-muted">OR</span>
                        <hr className="flex-grow-1" />
                      </div>
                    </div>

                    {/* GOOGLE BUTTON */}
                    <div className="col-12">
                      <div id="googleSignUpDiv" className="d-flex justify-content-center"></div>
                    </div>

                    {/* LOGIN LINK */}
                    <div className="col-12 text-center mt-3">
                      <p className="mb-1 text-muted">Already have an account?</p>
                      <Link to="/login" className="fw-bold text-decoration-none">
                        Sign In →
                      </Link>
                    </div>

                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Signup;
